const PRODUCT_REGEX = /product="([^"]+)"/g;

export const extractLuminaLinkProducts = (luminaContentMap: Record<string, string>): string[] => {
	const products: string[] = [];
	for (const value of Object.values(luminaContentMap)) {
		for (const match of value.matchAll(PRODUCT_REGEX)) {
			products.push(match[1]);
		}
	}
	return products;
};
